<template>
  <div>
    <Header class="fixed-bar" style="z-index: 100" />

    <!-- <div class="d-flex" style="min-height: 100vh">
      <div class="d-none d-sm-flex" style="min-width: 280px">
        <QuickMenu :mode="'manage'" class="px-2" />
      </div>
      <v-row no-gutters class="d-flex justify-center">
        <v-col cols="12" md="10" lg="8" class="px-6">
          <router-view />
        </v-col>
      </v-row>
    </div> -->

    <router-view />

    <Footer ref="footer" style="position: absolute; bottom: 0; width: 100%" />
    <!-- <BottomNavigation
      v-if="$vuetify.breakpoint.width < 600"
      class="fixed-bar"
      style="z-index: 100; bottom: 0"
    /> -->
  </div>
</template>

<script>
import Header from "../../components/Common/Header.vue";
import Footer from "../../components/Common/Footer.vue";
// import QuickMenu from "../../components/Common/QuickMenu.vue";
// import BottomNavigation from "../../components/Common/BottomNavigation.vue";

export default {
  components: {
    Header,
    Footer,
    // QuickMenu,
    // BottomNavigation,
  },
  data() {
    return {
      sheet: false,
    };
  },
  mounted() {
    // console.log(this.$refs.footer.$el.children[0].style);
  },
};
</script>

<style scoped></style>
